import React from 'react'
import { useState } from 'react';

import { graphql, useStaticQuery } from "gatsby"
import { Bar, Radar } from 'react-chartjs-2'

import { getBaseChartBarLine, spreadDatapoints } from './ChartUtils'
// import CmpFilterList from "./CmpFilterList"
import CmpEntidadesList from "./CmpEntidadesList"

const RptAnualXRegistroVehicular = (props) => {
  const [filter, setFilter] =  useState({key: 'Aguascalientes', label: 'Tiendas y Ocio'});
  const [chartType, setChartType] =  useState('bar');  
  
  const filterList = [
    {key: 'TiendasYOcio', label: 'Tiendas y Ocio'},
  ];
  // setFilter(filterList[0]);

  function onFilterSelected(vfilter, e){
    setFilter(vfilter);
  }

  return(
    
    <div className="row">  
      <div className="col-lg-3">
        {/* <CmpFilterList value={filter} filters={filterList} onChangeValue={onFilterSelected}></CmpFilterList>         */}
        <CmpEntidadesList value="Nacional" onChangeValue={onFilterSelected} removeNacional={true}></CmpEntidadesList>
      </div>      
      <div className="col-lg-9">
        <div className="rpt-chart-types">
            {/* <a className="default-btn small" href="#/" onClick={(e) => {setChartType('radar'); e.preventDefault();} }><i className="flaticon-view"></i>Radar</a> */}
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('bar'); e.preventDefault();} }><i className="flaticon-view"></i>Bar</a>
            {/* <a className="default-btn small" href="#/" onClick={(e) => {setChartType('stacked'); e.preventDefault();} }><i className="flaticon-view"></i>Stacked</a> */}
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('line'); e.preventDefault();} }><i className="flaticon-view"></i>Line</a>
        </div>        
        <TheChart value="" filter={filter} chartType={`${chartType}`} />
      </div>
    </div>    
  )

}


export default RptAnualXRegistroVehicular


// ====================== The chart

export const query = graphql`
{
  bd: allBdanualCsv(sort: {fields: Entidad}) {
    Automoviles: nodes {
      Oficial: Automoviles_Oficial
      Particular: Automoviles_Particular
      Publico: Automoviles_Publico
      filter: Entidad      
    }
    Camiones_y_camionetas: nodes {
      Oficial: Camiones__y_camionetas_de_carga_Oficial
      Particular: Camiones__y_camionetas_de_carga_Particular
      Publico: Camiones__y_camionetas_de_carga_Publico
      filter: Entidad      
    }
    Camiones_para_pasajeros: nodes {
      Oficial: Camiones_para_pasajeros_Oficial
      Particular: Camiones_para_pasajeros_Particular
      Publico: Camiones_para_pasajeros_Publico
      filter: Entidad      
    }    
    Motocicletas: nodes {
      Oficial: Motocicletas_Oficial
      Particular: Motocicletas_Particular
      Publico: Motocicletas_Publico
      filter: Entidad      
    }    
  }
}

`
const TheChart = (props) => {
    const data = useStaticQuery(query)
    let sortBy = null
    let fill = props.chartType == 'radar' ? true : false
    let chart = getBaseChartBarLine(data, props.filter ? props.filter : null, props.chartType, false, fill, sortBy, spreadDatapoints)
    return(
        <div className="rpt-chart">            
            <h4>{chart.title}</h4>
            
            { props.chartType == 'radar' && <Radar data={chart.data} options={{ legend: {position: 'top'} 
              ,scale: { ticks: {  callback: function(value, index, values) { return (value/1000) + ' K';}   }  }

              ,tooltips: {                
                callbacks: {
                    title: (tooltipItem, data) => data.labels[tooltipItem[0].index], 
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label || '';
                        if (label) {label += ': ';}
                        label += (tooltipItem.yLabel).toLocaleString('es-MX', {maximumFractionDigits:2})
                        return label;
                    }
                }
              }

            }}/> }            
            
            { props.chartType == 'stacked' && <Bar data={chart.data} options={{ legend: {position: 'top'} ,scales: { xAxes: [{stacked: true}],yAxes: [{stacked: true}]}}}/> }
            
            { props.chartType != 'radar' && <Bar data={chart.data} options={{ legend: {position: 'top'} 
              ,scales: { yAxes: [ {ticks: { callback: function(value, index, values) { return (value/1000) + ' K';}   } } ] }

              ,tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label || '';
                        if (label) {label += ': ';}
                        label += (tooltipItem.yLabel).toLocaleString('es-MX', {maximumFractionDigits:2})
                        return label;
                    }
                }
              }

            }}/> }            

        </div>
    )
}

